import {styled} from "@mui/material/styles";
import {Button, Paper, Typography} from "@mui/material";

// Keeps the terms checkbox and Save Changes in reach while scrolling the sections above.
export const EditCompanyProfileSaveBar = styled(Paper)(() => ({
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.86rem 1.71rem',
  padding: '1rem 1.43rem',
  borderRadius: '0.57rem',
  boxShadow: '0 -2px 8px rgba(50, 69, 89, 0.06)',
}));

export const EditCompanyProfileLabelText = styled(Typography)(() => ({
  fontSize: '.85rem',
}));

export const EditCompanyProfileButton = styled(Button)(({theme}) => ({
  flexGrow: 1,
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    minWidth: '10.71em !important',
  }
}));
